import { render } from "./AppKëshilli.vue?vue&type=template&id=4e6ab611"
const script = {}

import "./AppKëshilli.vue?vue&type=style&index=0&id=4e6ab611&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__